export default {
    development: {
        url: "http://localhost:8080",
    },
    production: {
        url: "https://api.conselheirosdavisao.pt",
    },
};
